import { Component, OnInit } from '@angular/core';

@Component({
  standalone: true,
  imports: [],

  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
